/* Whether the device has a network at all, kept current as it comes and goes.
 * navigator.onLine is false only where there is none, so a weak signal still
 * reads as a network and a request can still fail on one.
 */
import { useSyncExternalStore } from "react";

function subscribe(change: () => void): () => void {
  window.addEventListener("online", change);
  window.addEventListener("offline", change);
  return () => {
    window.removeEventListener("online", change);
    window.removeEventListener("offline", change);
  };
}

export function useHasNetwork(): boolean {
  return useSyncExternalStore(subscribe, () => navigator.onLine);
}
